export default "__VITE_ASSET__tMfdBzmx__"